import React, { FC, VFC } from 'react';

import { Link } from 'wouter';

import { RecommendedContainerJson, TrackRecommendedContentFn } from '/types';
import { contentTypeToPath } from '/utils/functions';
import { Trans } from '/utils/translations';

import styles from './RecommendedColumn.scss';

type RecommendedColumnProps = Pick<RecommendedContainerJson, 'elements'> & {
  trackRecommendedContent: TrackRecommendedContentFn;
};

const SpaLinkWithFallback: FC<{
  children: React.ReactNode;
  item: RecommendedContainerJson['elements'];
  onClick: () => void;
}> = ({ item, onClick, children }) =>
  item.source === 'effortless' && item.contentType && item.slug ? (
    <Link
      href={`/${contentTypeToPath(item.contentType)}/${item.slug}`}
      onClick={onClick}
    >
      <a>{children}</a>
    </Link>
  ) : (
    <a href={item.url} onClick={onClick}>
      {children}
    </a>
  );

export const RecommendedColumn: VFC<RecommendedColumnProps> = ({
  elements,
  trackRecommendedContent,
}) => (
  <div className={styles['article-overlay']}>
    <SpaLinkWithFallback
      item={elements}
      onClick={(): void => trackRecommendedContent(elements.title)}
    >
      <div
        className={styles['article-outer-box']}
        style={
          elements.image === ''
            ? { backgroundColor: styles['card-colour'] }
            : { backgroundImage: `Url(${elements.image})` }
        }
      >
        <div className={styles['article-title']}>
          <h3>{elements.title}</h3>
          <span>
            <Trans>Read more</Trans>
          </span>
        </div>
        <time>{elements.date}</time>
      </div>
    </SpaLinkWithFallback>
  </div>
);
